import { CommonModule } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@ngneat/transloco";
import { TicketService } from "app/modules/admin/tickets/services/ticket.service";
import { DuplicateCampaignComponent } from "app/modules/admin/campaign/details/tabs/duplicate-campaign/duplicate-campaign.component";
import { StorageService } from "app/services/storage.service";
import { TextInputFormFieldComponent } from "app/shared/components/form-fields/text-input-form-field/text-input-form-field.component";
import { FormSectionComponent } from "app/shared/components/form-section/form-section.component";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { MediaSelectorComponent } from "app/shared/components/media-selector/media-selector.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { AcButtonComponent } from "../../../../shared/components/ac-button/ac-button.component";

@Component({
    selector: "contact-us",
    standalone: true,
    imports: [
    CommonModule,
    ReactiveFormsModule,
    FormSectionComponent,
    TranslocoModule,
    MatIconModule,
    MatButtonModule,
    TextInputFormFieldComponent,
    MatDialogModule,
    MediaSelectorComponent,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    AcButtonComponent
],
    templateUrl: "./contact-us.component.html",
    styleUrl: "./contact-us.component.scss",
})
export class ContactUsComponent implements OnDestroy, OnInit {
    form: FormGroup = new FormGroup({
        email: new FormControl({ value: "", disabled: true }),
        subject: new FormControl("", [Validators.required]),
        message: new FormControl("", [Validators.required]),
    });

    isLoading: boolean = false; // Carga

    private _unsubscribeAll: Subject<void> = new Subject<void>();
    currentUser: any;

    constructor(
        private _localeService: StorageService,
        private _ticketService: TicketService,
        private _dialogRef: MatDialogRef<DuplicateCampaignComponent>,
        private _toastr: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        this.currentUser = this._localeService.getItem("user");
        this.form.get("email").setValue(this.currentUser.email);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    save(): void {
        if (this.form.valid) {
            this.isLoading = true;
            this.form.value.email = this.form.get("email").value;
            const dataToSend = {
                title: this.form.get("subject").value,
                description: this.form.get("message").value,
                user_id: this.currentUser.id.toString(),
            };
            this._ticketService.create(dataToSend).subscribe({
                next: () => {
                    this._toastr.success("Ticket created successfully!");
                    this._dialogRef.close("save");
                    this.isLoading = false;
                },
                error: (err) => {
                    this._toastr.error(err?.message || "Error creating the ticket");
                    this.isLoading = false;
                },
            });
        } else {
            this._toastr.error("Please fill out the required fields correctly.");
        }
    }

    close() {
        this._dialogRef.close("cancel");
    }
}
